<template lang="pug">
modal#email-history-modal(
  :no-footer='true'
  :title='$t("modal.emailHistory.title")'
  ref='modal'
  size='lg'
)
  .recipient-info(v-if='emailHistory.length')
    .recipient-info-item
      strong {{ $t('modal.emailHistory.recipient') }}:
      span {{ emailHistory[0].recipient_name }}
    .recipient-info-item
      strong {{ $t('modal.emailHistory.email') }}:
      span {{ emailHistory[0].recipient_email }}
  .table-responsive(v-if='emailHistory.length')
    table.table.table-hover.mb-0
      thead
        tr
          th(scope='col') {{ $t('modal.emailHistory.sentAt') }}
          th(scope='col') {{ $t('modal.emailHistory.type') }}
          th(scope='col') {{ $t('modal.emailHistory.status') }}
      tbody
        tr(:key='item.id' v-for='item in emailHistory')
          td {{ formatDateTime(item.sent_at) }}
          td {{ $t(`modal.emailHistory.typeLabels.${item.type}`) }}
          td
            span.text(:class='statusClass(item.status)') {{ $t(`modal.emailHistory.statusLabels.${item.status}`) }}
  .text-center.py-4(v-else)
    p.mb-0 {{ $t('modal.emailHistory.noHistory') }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'EmailHistoryModal',
  components: {
    Modal,
  },
  props: {
    emailHistory: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    statusClass(status) {
      const map = {
        queued: 'text-warning',
        sent: 'text-info',
        failed: 'text-danger',
      };
      return map[status] || '';
    },
    formatDateTime(dateString) {
      if (!dateString) {
        return '';
      }
      const date = new Date(dateString);
      return date.toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'medium',
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.recipient-info
  display: flex
  flex-wrap: wrap
  gap: 0.5rem 1.5rem
  padding: 0 0 1rem 0
  margin-bottom: 1rem
  border-bottom: 1px solid #dee2e6

.recipient-info-item
  strong
    margin-right: 0.3rem
    font-weight: 600
    color: #6c757d
    font-size: 13px
  span
    font-size: 14px

.table
  th
    font-weight: 600
    font-size: 13px
    color: #6c757d
    border-bottom: 2px solid #dee2e6
  td
    font-size: 14px
    vertical-align: middle
</style>
